module.exports = __webpack_public_path__ + "images/logo-goldman-sacks.svg";